import { render, staticRenderFns } from "./EditCandidate.vue?vue&type=template&id=45c5cc76&"
import script from "./EditCandidate.vue?vue&type=script&lang=js&"
export * from "./EditCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports